import React from "react";

function Subnet() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      version="1.1"
      viewBox="0 0 24 24"
    >
      <path fill="none" d="M0 0h24v24H0z"></path>
      <path d="M8.23 5.48L2.82 12l5.41 6.52 1.54-1.28L5.42 12l4.35-5.24zm7.54 0l-1.54 1.28L18.58 12l-4.35 5.24 1.54 1.28L21.18 12zM11 11v2h2v-2z"></path>
    </svg>
  );
}

export default Subnet;
